var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isFree)?[_vm._v("\n    "+_vm._s(_vm.$t('product.free'))+"\n  ")]:(_vm.price)?[_vm._v("\n    "+_vm._s(_vm.price.getSymbol() + ' ' + _vm.price.toFormat('0,0'))+"\n  ")]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }